import { Accomodation } from './get'


export const URL = '/v2/pms/accomodations/:id/'

export type Req = {
  name?: string
  address?: string
  latitude?: number
  longitude?: number
}

export type Resp = Accomodation